import React from 'react';
import { Link } from 'react-router-dom';
import { useLanguage } from '../../hooks/useLanguage';

const OurPuttiesProducts = () => {
  const { getLocalizedPath } = useLanguage();

  const gridItems = Array.from({ length: 2 }).map((_, i) => ({
    id: i + 1,
    name: 'Jacket',
    price: i % 4 === 0 ? '395,00 €' : '390,00 €',
    image: '/assets/paint-product-1.webp',
  }));
  return (
    <div className="my-20 md:my-[120px] w-full">
      <div className="py-10 sm:py-[90px] w-full">
        <h2 className="text-center text-[#1D1D1F] text-[32px] sm:text-[57px] leading-[40px] sm:leading-[81px] font-normal libre-baskerville">
          Our Putties Products
        </h2>
        <div className="mt-7 sm:mt-[50px] max-w-[685px] mx-auto w-full justify-items-center grid grid-cols-1 sm:grid-cols-2 gap-4 sm:gap-8 lg:gap-[50px]">
          {gridItems.map((p) => (
            <div
              key={p.id}
              className="bg-white rounded-[15px] mx-auto max-w-[287px] w-full hover:shadow-md transition-all duration-300"
            >
              <Link to={getLocalizedPath('/product')} className="block">
                <div className="rounded-[15px] bg-[#EDEDED] overflow-hidden h-[360px] flex items-center justify-center">
                  <img
                    src={p.image}
                    alt={p.name}
                    className="w-full h-full object-contain"
                  />
                </div>
              </Link>
              <div className="pt-6 text-center pb-4">
                <p className="text-[#A0A0A0] text-[12px] leading-[24px] font-medium">
                  Limited Edition
                </p>
                <h3 className="text-[#1D1D1F] text-[16px] leading-[24px] font-medium mt-[9px]">
                  {p.name}
                </h3>
                <p className="text-[#1D1D1F] text-[16px] leading-[22px] font-medium">
                  {p.price}
                </p>
              </div>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
};

export default OurPuttiesProducts;
